import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps, CardContent, CardActions, CardHeader } from '@mui/material';
import { StyledCard } from './Card.style';

export interface CardProps extends Omit<MuiCardProps, 'variant'> {
  /**
   * The variant of the card
   */
  variant?: 'elevation' | 'outlined';
  /**
   * Whether the card is hoverable
   */
  hoverable?: boolean;
  /**
   * The header content of the card
   */
  header?: React.ReactNode;
  /**
   * The main content of the card
   */
  children?: React.ReactNode;
  /**
   * The actions section of the card
   */
  actions?: React.ReactNode;
  /**
   * Custom padding for the content
   */
  contentPadding?: number | string;
}

export const Card: React.FC<CardProps> = ({
  variant = 'elevation',
  hoverable = false,
  header,
  children,
  actions,
  contentPadding,
  ...props
}) => {
  return (
    <StyledCard
      variant={variant}
      hoverable={hoverable}
      {...props}
    >
      {header && (
        <CardHeader title={header} />
      )}
      
      {children && (
        <CardContent sx={contentPadding ? { padding: contentPadding } : undefined}>
          {children}
        </CardContent>
      )}
      
      {actions && (
        <CardActions>
          {actions}
        </CardActions>
      )}
    </StyledCard>
  );
}; 